var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({class:_vm.classNames,attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},'button',_vm.$props,false),[_vm._t("icon"),_vm._v(" "),(_vm.hasText)?_c('div',{staticClass:"text-label"},[_vm._t("default")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }